module.exports = __webpack_public_path__ + "static/img/Ben-Cunnington.191265e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ben-Cunnington.jpg
// module id = gHhG
// module chunks = 0